<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else>
      <div class="customer-tab">
        <div slot="no-body" class="tabs-container pt-6" id="view-customer-tab">
          <div>
            <vx-card no-shadow>
              <vs-table
                :max-items="descriptionItems[0]"
                @selected="stockUploadClickView"
                pagination
                :data="searches"
                description
                search
                :description-items="descriptionItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="list-heading">
                    {{ $t("stockUpload.label.header") }}
                  </div>
                  <div class="mr-2 order-1">
                    <v-select
                      label="mCodeValue"
                      v-model="selectedName"
                      :options="['tayana dealer', 'DEALER']"
                      :placeholder="$t('inventory.label.SelectBusinessEntity')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      @input="haldleSelectedOption"
                      class="w-full mb-2 font-semibold header-dropdown1"
                    ></v-select>
                  </div>
                  <div class="mr-2 order-1">
                    <v-select
                      label="mCodeValue"
                      v-model="selectedDescription"
                      :options="['SIM Serial', 'Mobile Number']"
                      :placeholder="$t('inventory.label.SelectDescription')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      @input="haldleSelectedOption"
                      class="w-full mb-2 font-semibold header-dropdown2"
                    ></v-select>
                  </div>
                  <div class="mr-2 order-1">
                    <v-select
                      label="mCodeValue"
                      v-model="selectedStatus"
                      :options="['Available', 'IN User']"
                      :placeholder="$t('inventory.label.SelectStatus')"
                      @input="haldleSelectedOption"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="w-full mb-2 font-semibold header-dropdown3"
                    ></v-select>
                  </div>
                  <div class="mr-2 mb-1 order-1 header-button">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="$router.push({ name: 'Add Stock Upload' })"
                      size="small"
                      >{{ $t("inventory.label.CreateStockUpload") }}</vs-button
                    >
                  </div>
                </template>
                <template slot="thead">
                  <vs-th>{{
                    $t("inventory.label.business_entity_name")
                  }}</vs-th>
                  <vs-th>{{ $t("stockUpload.label.Item Description") }}</vs-th>
                  <vs-th>{{ $t("stockUpload.label.Item Code") }}</vs-th>
                  <vs-th>{{ $t("stockUpload.label.AccountNumber") }}</vs-th>
                  <vs-th>{{ $t("stockUpload.label.Chip Id") }}</vs-th>
                  <vs-th>{{ $t("stockUpload.label.Is Pairing") }}</vs-th>
                  <vs-th>{{ $t("stockUpload.label.Paired Item") }}</vs-th>
                  <vs-th>{{ $t("stockUpload.label.Serial Number") }}</vs-th>
                  <vs-th>{{ $t("stockUpload.label.Warranty Date") }}</vs-th>
                  <vs-th>{{ $t("stockUpload.label.Item Model") }}</vs-th>
                  <vs-th>{{ $t("inventory.label.status") }}</vs-th>
                  <vs-th class="tHeadCenter">{{
                    $t("inventory.label.action")
                  }}</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="search"
                    v-for="(search, index) in data"
                  >
                    <vs-td :data="search.entityname">{{
                      search.entityname
                    }}</vs-td>
                    <vs-td :data="search.itemDescription">{{
                      search.itemDescription
                    }}</vs-td>
                    <vs-td :data="search.itemCode">{{ search.itemCode }}</vs-td>
                    <vs-td :data="search.accountNumber">{{
                      search.accountNumber
                    }}</vs-td>
                    <vs-td :data="search.Chipid">{{ search.Chipid }}</vs-td>
                    <vs-td :data="search.isPairing">{{
                      search.isPairing
                    }}</vs-td>
                    <vs-td :data="search.PairedItem">{{
                      search.PairedItem
                    }}</vs-td>

                    <vs-td :data="search.serialNumber">{{
                      search.serialNumber
                    }}</vs-td>
                    <vs-td :data="getDate(search.warranty_date)">{{
                      getDate(search.warranty_date)
                    }}</vs-td>
                    <vs-td :data="search.itemModel">{{
                      search.itemModel
                    }}</vs-td>
                    <vs-chip
                      :color="
                        getOrderStatusColorStock(
                          search.orderdQuantity == search.PairedItem
                            ? 'Available'
                            : 'IN User'
                        )
                      "
                      class="product-order-status"
                      style="margin-top: 15px"
                      >{{
                        search.orderdQuantity == search.PairedItem
                          ? "Available"
                          : "IN User"
                      }}
                    </vs-chip>
                    <vs-td :data="search" class="whitespace-no-wrap">
                      <div class="container_img">
                        <feather-icon
                          icon="EditIcon"
                          :title="$t('inventory.label.Edit')"
                          svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                          @click.stop="editDataPopup(search)"
                          class="icon_row"
                        />
                        <button
                          class="border-none view_editTable_btn"
                          @click.stop="viewTrakerPopup(search.serialNumber)"
                        >
                          <img
                            src="@/assets/images/icons/track_history.svg"
                            :title="$t('inventory.label.TrackHistory')"
                            class="h-5 w-5 icon_row"
                          />
                        </button>
                        <button
                          v-if="search.status == 'Available'"
                          class="bGNone border-none view_editTable_btn"
                          @click.stop="
                            editJobsPopup = true;
                            delId = search.id;
                          "
                        >
                          <feather-icon
                            icon="TrashIcon"
                            :title="$t('inventory.label.Delete')"
                            @click.stop="
                            editJobsPopup = true;
                            delId = search.id;
                          "
                            svgClasses="w-5 h-5 text-danger stroke-current cursor"
                            class="icon_row"
                          />
                        </button>
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vx-card>
          </div>
        </div>
      </div>
      <div class="centerx">
        <vs-popup
          class="popup-close"
          :title="$t('inventory.label.EditItemDetail')"
          :active.sync="updateCraditPopup"
        >
          <ValidationObserver ref="observer">
            <form>
              <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                <div class="vx-col sm:w-full w-full">
                  <div
                    v-if="details.status == 'Available'"
                    class="dropdown-with-label"
                  >
                    <small class="date-label font-semibold"
                      >{{ $t("stockUpload.label.add.Quality")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="quantity"
                    >
                      <v-select
                        label="mCodeValue"
                        v-model="detail.quality"
                        :reduce="(obj) => obj.mCodeValue"
                        :options="details.qualityDatas"
                        :placeholder="$t('inventory.label.SelectItem')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full mb-2 font-semibold"
                      >
                        <template v-slot:option="option">{{
                          option.mCodeValue
                        }}</template>
                      </v-select>
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('inventory.label.ProvisionSerialNumber')"
                  >
                    <vs-input
                      :label="$t('inventory.label.ProvisionSerialNumber')"
                      type="text"
                      class="w-full mb-2 font-semibold"
                      v-model="detail.provisioningSerialNumber"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('inventory.label.SerialNumber')"
                    :key="resetKey"
                  >
                    <vs-input
                      v-if="details.status == 'Available'"
                      :label="$t('inventory.label.SerialNumber')"
                      type="text"
                      class="w-full mt-6 mb-2 font-semibold"
                      v-model="detail.serialNumber"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-row my-2" style="margin-left: 20rem">
                <span class="ml-1 mr-2">
                  <vs-button icon-pack="feather" @click="saveQuality">{{
                    $t("inventory.label.Submit")
                  }}</vs-button>
                </span>
              </div>
            </form>
          </ValidationObserver>
        </vs-popup>
      </div>
      <div class="centerx">
        <vs-popup
          class="popup-close"
          :title="$t('inventory.label.TrackHistory')"
          :active.sync="updateCraditPopup1"
        >
          <form>
            <vs-table :data="historys">
              <template slot="thead">
                <vs-th>{{ $t("inventory.label.RefType") }}</vs-th>
                <vs-th>{{ $t("inventory.label.TransactionDate") }}</vs-th>
                <vs-th>{{ $t("inventory.label.Movement") }}</vs-th>
                <vs-th>{{ $t("inventory.label.FromOffice") }}</vs-th>
                <vs-th>{{ $t("inventory.label.ToOffice") }}</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr
                  :key="index"
                  :data="history"
                  v-for="(history, index) in data"
                >
                  <vs-td :data="history.refType">{{ history.refType }}</vs-td>
                  <vs-td :data="getDate(history.transactionDate)">{{
                    getDate(history.transactionDate)
                  }}</vs-td>
                  <vs-td :data="history.movement">{{ history.movement }}</vs-td>
                  <vs-td :data="history.fromOffice">{{
                    history.fromOffice
                  }}</vs-td>
                  <vs-td :data="history.toOffice">{{ history.toOffice }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>

            <div class="vx-row float-right my-2">
              <span class="ml-1 mr-5">
                <vs-button type="border" @click="updateCraditPopup1 = false">{{
                  $t("inventory.label.Done")
                }}</vs-button>
              </span>
            </div>
          </form>
        </vs-popup>
      </div>

      <!-- <div class="centerx">
        <vs-popup
          class="popup-close"
          :title="$t('stockTransfer.label.Delete Item Sale')"
          :active.sync="editJobsPopup"
        >
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col sm:w-full w-full">
              <div class="vx-col sm:w-full w-full">Are you sure?</div>
            </div>
          </div>
          <div class="vx-row">
            <span class="ml-4 mr-1">
              <vs-button type="border" @click="editJobsPopup = false">{{
                $t("inventory.label.Reset")
              }}</vs-button>
            </span>
            <span class="ml-1 mr-2">
              <vs-button @click="deleteTeam(delId)" color="warning">{{
                $t("stockTransfer.label.Ok")
              }}</vs-button>
            </span>
          </div>
        </vs-popup>
      </div> -->

      <ConfirmDelete
        :title="deletePopupTitle"
        :isOpen="deleteItemPopup"
        @onCancel="deleteItemPopup = false"
        @onConfirm="deleteTeamTransfer(type, delId)"
      />
      <delete-popup
        :deletePopup="editJobsPopup"
        :title="$t('inventory.label.DeleteItemDetails')"
        @deletePressed="deleteTeam(delId)"
        @cancelPressed="editJobsPopup = false"
      >
      </delete-popup>
    </div>
  </div>
</template>
<script>
import {
  editGrnTemplate,
  viewGRVStockTransfer,
  getSqlSearch,
  getByItemDetailsTemplate,
  getByItemDetailsdropdown,
  deleteItemDetail,
  saveQuality,
  getMrnHistory,
  viewMRNStockTransfer,
  deleteItemSale,
} from "@/http/inventory";
import { AtomSpinner } from "epic-spinners";
import moment from "moment";
import vSelect from "vue-select";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import confirmDelete from "@/components/common/confirmDelete";
import { mapState } from "vuex";

export default {
  components: {
    AtomSpinner,
    vSelect,
    ValidationObserver,
    ValidationProvider,

    ConfirmDelete: confirmDelete,
  },
  data() {
    return {
      loading: false,
      editGrnPopup: false,
      resetKey: 0,
      searchOption: 0,
      purchaseDate: "",
      editOrderQty: 0,
      deleteItemPopup: false,
      selectedName: "",
      selectedDescription: "",
      selectedStatus: "",
      saveGrnPayload: {
        purchaseDate: "",
        orderdQuantity: "",
        locale: "en",
        dateFormat: "dd MMMM yyyy",
        purchaseNo: "",
        supplierId: "",
        officeId: "",
        itemMasterId: "",
      },
      descriptionItems: [10, 20, 30],
      value: ["Inactive", "New", "Success"],
      grn: {},
      goods: [],
      searches: [],
      updateCraditPopup: false,
      updateCraditPopup1: false,
      editJobsPopup: false,
      details: {},
      detail: {
        quality: "",
        serialNumber: "",
        provisioningSerialNumber: "",
      },
      qualityDatas: [],
      historys: {
        fromOffice: "",
        itemDescription: "",
      },
      history: [],
      stockTransferData: [],
      popupDeleteStockTransfer: false,
      showBtnRadioTransfer: "Item",
      type: "",
      deletePopupTitle: "",
    };
  },

  computed: {
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
      filteredStockList: (state) => state.inventory.filteredStock,
    }),
  },
  methods: {
    stockUploadClickView(item) {
      if (item.clientId)
        this.$router.push({
          path: `/customers/view_customer/${item.clientId}`,
        });
    },

    getOrderStatusColor(status) {
      if (status === "Pending") return "orange";
      return "success";
    },
    getDate(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },

    async haldleSelectedOption() {
      if (!this.selectedStatus) {
        this.selectedStatus = "";
      }
      if (!this.selectedName) {
        this.selectedName = "";
      }
      if (!this.selectedDescription) {
        this.selectedDescription = "";
      }
      if (
        !this.selectedStatus &&
        !this.selectedName &&
        !this.selectedDescription
      ) {
        this.getSqlSearch();
      }
      const data = {
        status: this.selectedStatus,
        entityName: this.selectedName,
        description: this.selectedDescription,
      };
      try {
        await this.$store.dispatch("inventory/stockUploadfilterAction", data);
        this.searches = this.filteredStockList.pageItems;
      } catch (error) {
        throw Error(
          error.message ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    async getSqlSearch() {
      this.loading = true;
      try {
        const search = await getSqlSearch();
        this.searches = search.data.pageItems;
      } catch (error) {
        throw Error(
          error.message ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async editDataPopup(search) {
      const response = await getByItemDetailsTemplate();
      this.details = response.data;
      this.details["status"] = search.status;
      this.detail.serialNumber = search.serialNumber;
      this.detail.provisioningSerialNumber = search.Chipid;
      this.detail.quality = search.quality;
      this.itemId = search.id;
      this.resetKey++;
      this.updateCraditPopup = true;
    },
    async deleteTeam(id) {
      try {
        await deleteItemDetail(id);
        this.editJobsPopup = false;
        await getSqlSearch();
      } catch (error) {
        throw Error(
          error.message ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getByItemDetailsTemplate() {
      this.loading = true;
      try {
        const response = await getByItemDetailsTemplate();
        this.details = response.data;
      } catch (error) {
        throw Error(
          error.message ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async viewTrakerPopup(id) {
      const history = await getMrnHistory(id);
      this.historys = history.data.pageItems;
      this.updateCraditPopup1 = true;
    },

    async saveQuality() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      const postItemObj = {
        quality: this.detail.quality,
        provisioningSerialNumber: this.detail.provisioningSerialNumber,
      };
      if (this.details.status == "Available") {
        postItemObj["serialNumber"] = this.detail.serialNumber;
      }
      try {
        this.updateCraditPopup = false;
        const resp = await saveQuality(this.itemId, postItemObj);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Item Detail Updated successfully!",
          type: "success",
        });
        
          this.$router.push({
            path: "/inventory/stockupload",
          });
      

        this.getSqlSearch();
        this.getByItemDetailsTemplate();
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e;
        }
      }
    },

    getOrderStatusColorStock(status) {
      if (status === "Available") return "orange";
      return "success";
    },
  },
  mounted() {
    this.getSqlSearch();
    this.getByItemDetailsTemplate();
  },
  watch: {},
};
</script>
<style scoped>
.inventory_tabSec >>> .con-vs-tabs .con-ul-tabs {
  width: 40%;
  margin: 0 auto;
  border: 1px solid #c5d0df;
  border-radius: 6px;
}
.inventory_tabSec >>> .vs-tabs-primary .con-ul-tabs .line-vs-tabs {
  background: linear-gradient(
    118deg,
    rgba(var(--vs-primary), 1),
    rgba(var(--vs-primary), 0.7)
  ) !important;
  box-shadow: none !important;
}
.inventory_tabSec >>> .vs-tabs-primary .con-ul-tabs .activeChild button {
  color: #fff !important;
}
.inventory_tabSec >>> .activeChild button.vs-tabs--btn {
  background: linear-gradient(
    118deg,
    rgba(var(--vs-primary), 1),
    rgba(var(--vs-primary), 0.7)
  );
  padding-top: 10px;
  padding-bottom: 10px;
}

.inventory_tabSec >>> .vs-tabs--ul {
  padding-top: 0;
}
.inventory_tabSec >>> .vs-tabs-position-top .vs-tabs--ul {
  width: 100%;
}
.inventory_tabSec >>> .vs-tabs--li {
  display: inline-block !important;
  width: 33.33% !important;
}
.inventory_tabSec >>> .vs-tabs--li button.vs-tabs--btn span {
  text-transform: uppercase;
}
.product-order-status.vs-chip-success {
  background: #d5ebdb !important;
  border: 1px solid #34a853;
  color: #34a853 !important;
}
.product-order-status.vs-chip-orange {
  background: #fffae7 !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.view_editTable_btn {
  background: transparent;
  cursor: pointer;
}
.header-dropdown1 {
  min-width: 150px !important;
}
.header-dropdown2 {
  min-width: 155px !important;
}
.header-dropdown3 {
  min-width: 150px !important;
}
.header-button {
  height: 50px;
}
::v-deep .vs-table--search-input {
  width: 150px !important;
}
</style>
